import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const AppThemePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f0f8f0',      // lightest forest green
      100: '#dcefdc',     // lighter forest green
      200: '#b8dfb8',     // light forest green
      300: '#8fce8f',     // forest green tint
      400: '#66bd66',     // forest green shade
      500: '#2e7d32',     // primary forest green
      600: '#1b5e20',     // dark forest green
      700: '#0d4f13',     // deeper forest green
      800: '#0a3e0f',     // darkest forest green
      900: '#07270a',     // near black green
      950: '#041205',     // pure black green
    },
    
    secondary: {
      50: '#f5f2ed',      // lightest earth brown
      100: '#e8dfce',     // lighter earth brown
      200: '#d4c2a0',     // light earth brown
      300: '#bfa372',     // earth brown tint
      400: '#a68344',     // earth brown shade
      500: '#8d6e63',     // primary earth brown
      600: '#6d4c41',     // dark earth brown
      700: '#5d4037',     // deeper earth brown
      800: '#4e342e',     // darkest earth brown
      900: '#3e2723',     // near black brown
      950: '#1c0e0a',    
    },
  }
});